import { RateSheetGeneratorIndexResponse } from 'RtModels';
import { DataGridColumn } from 'RtUi/components/data/DataGrid/types';
import { BooleanDataGridColumn } from 'RtUi/components/data/DataGrid/columns/BooleanDataGridColumn';
import { DefaultDataGridColumn } from 'RtUi/components/data/DataGrid/columns/DefaultDataGridColumn';
import { IdDataGridColumn } from 'RtUi/components/data/DataGrid/columns/IdDataGridColumn';
import { IsActiveDataGridColumn } from 'RtUi/components/data/DataGrid/columns/IsActiveDataGridColumn';
import { SubscriptionDataGridColumn } from 'RtUi/components/data/DataGrid/columns/SubscriptionDataGridColumn';
import { TimeStampDataGridColumn } from 'RtUi/components/data/DataGrid/columns/TimeStampDataGridColumn';
import { LabelDataGridColumn } from 'RtUi/components/data/DataGrid/columns/LabelDataGridColumn';

export const getRateSheetGeneratorColumns = (): Array<
	DataGridColumn<RateSheetGeneratorIndexResponse>
> => [
	IdDataGridColumn({
		accessorKey: 'rateSheetGeneratorId'
	}),
	LabelDataGridColumn({
		accessorKey: 'label'
	}),
	IsActiveDataGridColumn({
		accessorKey: 'isActive'
	}),
	SubscriptionDataGridColumn({
		accessorKey: 'subscriptionId'
	}),
	BooleanDataGridColumn({
		accessorKey: 'isIddd',
		header: 'IDDD'
	}),
	BooleanDataGridColumn({
		accessorKey: 'isNanp',
		header: 'NANP'
	}),
	DefaultDataGridColumn({
		accessorKey: 'omitIsos',
		header: 'Omit ISOs'
	}),
	DefaultDataGridColumn({
		accessorKey: 'onlyIsos',
		header: 'Only ISOs'
	}),

	DefaultDataGridColumn({
		accessorKey: 'marginPercent',
		header: 'Margin %'
	}),
	DefaultDataGridColumn({
		accessorKey: 'marginMinimum',
		header: 'Margin Min'
	}),
	DefaultDataGridColumn({
		accessorKey: 'rateMultipliers',
		header: 'Rate Multipliers',
		isHidden: true
	}),
	DefaultDataGridColumn({
		accessorKey: 'roundingPrecision',
		header: 'Rounding Prec.'
	}),
	DefaultDataGridColumn({
		accessorKey: 'routingOptions',
		header: 'Options',
		isHidden: true
	}),
	TimeStampDataGridColumn({
		accessorKey: 'createdTs',
		header: 'Created'
	}),
	TimeStampDataGridColumn({
		accessorKey: 'updatedTs',
		header: 'Updated'
	})
];
